import { ProjectHoursTable } from "@/components/project-hours-table";
import { createFileRoute } from "@tanstack/react-router";
import { debounce, parseAsString, useQueryStates } from "nuqs";

export const Route = createFileRoute("/dashboard/admin/time_tracking/")({
  component: RouteComponent,
});

function RouteComponent() {
  const [filters, setFilters] = useQueryStates({
    worker: parseAsString,
    project: parseAsString,
    dateRange: parseAsString,
    search: parseAsString,
    payPeriodStart: parseAsString,
    payPeriodEnd: parseAsString,
  }, { history: "replace" });

  const handleFilterChange = (updates: Partial<typeof filters>) => {
    // Apply debounce only for search field
    const options = updates.search !== undefined && updates.search !== "" 
      ? { limitUrlUpdates: debounce(300) }
      : undefined;
    
    setFilters(updates, options);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-1 sm:p-4">
      <h1 className="mb-4 text-2xl font-bold">Project Hours Overview</h1>
      <ProjectHoursTable
        showAgencyNote={true}
        filterWorker={filters.worker ?? undefined}
        filterProject={filters.project ?? undefined}
        filterDateRange={filters.dateRange ?? undefined}
        filterSearch={filters.search ?? undefined}
        filterPayPeriodStart={filters.payPeriodStart ?? undefined}
        filterPayPeriodEnd={filters.payPeriodEnd ?? undefined}
        onFilterChange={handleFilterChange}
      />
    </div>
  );
}
